<template>
    <div>
        <el-form-item label="数据类型">
            <el-select v-model="component_source.type" placeholder="请选择">
                <el-option v-for="item, index in SourceOptions" :label="item.name" :value="item.value"
                    :key="index"></el-option>
            </el-select>
        </el-form-item>
        <!-- material_group -->
        <el-form-item label="素材组" v-if="component_source.type == 'material_group'">
            <el-autocomplete clearable v-model="queryStringMaterialGroup" :fetch-suggestions="querySearchMaterialGroup"
                placeholder="搜索/选择素材组" @select="(item) => handleSelectMaterialGroup(item)"></el-autocomplete>
        </el-form-item>
        <!-- category_tags -->
        <el-form-item label="大栏目" v-if="component_source.type == 'category_tags'">
            <el-autocomplete clearable v-model="queryStringCategory" :fetch-suggestions="querySearchCategory"
                placeholder="搜索/选择大栏目" @select="(item) => handleSelectCategory(item)"></el-autocomplete>
        </el-form-item>
        <el-form-item label="图片标签组" v-if="component_source.type == 'category_tags'">
            <el-autocomplete clearable v-model="queryStringTagGroup" :fetch-suggestions="querySearchTagGroup"
                placeholder="搜索/选择图片标签组" @select="(item) => handleSelectTagGroup(item)"></el-autocomplete>
        </el-form-item>
        <!-- tags -->
        <el-form-item label="图片标签" v-if="component_source.type == 'tags'">
            <el-autocomplete clearable v-model="queryStringTag" :fetch-suggestions="querySearchTag"
                placeholder="搜索/选择图片标签" @select="(item) => handleSelectTagsTag(item)"></el-autocomplete>
        </el-form-item>
        <el-form-item label=" " v-if="(component_source.type == 'tags' && component_source.ignore.tag_list)">
            <div style="width:100%">
                <el-row v-for="item, index in component_source.ignore.tag_list" :key="index">
                    <el-col :span="12">
                        {{ item.value }}
                    </el-col>
                    <el-col :span="4">
                        <el-icon @click="handleMoveUpTag(item)">
                            <ArrowUpBold />
                        </el-icon>
                    </el-col>
                    <el-col :span="4">
                        <el-icon @click="handleMoveDownTag(item)">
                            <ArrowDownBold />
                        </el-icon>
                    </el-col>
                    <el-col :span="4">
                        <el-icon @click="handleDeleteTag(item)">
                            <CloseBold />
                        </el-icon>
                    </el-col>
                </el-row>
            </div>
        </el-form-item>


        <!-- photos -->
        <el-form-item label="大栏目" v-if="component_source.type == 'photos'">
            <el-autocomplete clearable v-model="queryStringCategory" :fetch-suggestions="querySearchCategory"
                placeholder="搜索/选择大栏目" @select="(item) => handleSelectCategory(item)"></el-autocomplete>
        </el-form-item>
        <el-form-item label="图片标签" v-if="component_source.type == 'photos'">
            <el-autocomplete clearable v-model="queryStringTag" :fetch-suggestions="querySearchTag"
                placeholder="搜索/选择图片标签" @select="(item) => handleSelectTag(item)"></el-autocomplete>
        </el-form-item>

        <!-- tag_photos -->
        <el-form-item label="图片标签" v-if="component_source.type == 'tag_photos'">
            <el-autocomplete clearable v-model="queryStringTag" :fetch-suggestions="querySearchTag"
                placeholder="搜索/选择图片标签" @select="(item) => handleSelectTag(item)"></el-autocomplete>
        </el-form-item>

    </div>

</template>

<script>

import { GetMaterialGroupList, GetAtlasCategoryList, GetAtlasTagGroup, GetAtlasTagList } from '@/request/api'
import { CloseBold, ArrowDownBold, ArrowUpBold } from '@element-plus/icons-vue'

export default {
    props: ['component_source'],
    components: {
        CloseBold, ArrowDownBold, ArrowUpBold
    },
    data() {
        return {
            SourceOptions: [{ name: 'material_group', value: 'material_group' },
            { name: 'category_tags', value: 'category_tags' },
            { name: 'tags', value: 'tags' },
            { name: 'photos', value: 'photos' },
            { name: 'tag_photos', value: 'tag_photos' }],
            queryStringMaterialGroup: '',
            queryStringCategory: '',
            queryStringTagGroup: '',
            queryStringTag: '',
            queryTagList: []
        }
    },
    mounted() {
        // console.log('WWWWWWWWWWWWWWWWWWW', this.component_source.ignore)
        this.queryStringMaterialGroup = this.component_source.ignore.material_group_name
        this.queryStringCategory = this.component_source.ignore.category_name
        this.queryStringTagGroup = this.component_source.ignore.tag_group_name
        this.queryStringTag = this.component_source.ignore.tag_name
    },
    methods: {
        //搜索素材组
        querySearchMaterialGroup(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetMaterialGroupList(params)
                .then(data => {
                    var list = []
                    if (data.list) {
                        list = data.list.map(item => {
                            return {
                                value: item.name,
                                id: item.materialGroupID
                            }
                        })
                    }
                    cb(list)
                })
        },
        //搜索大栏目
        querySearchCategory(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasCategoryList(params)
                .then(data => {
                    console.log('GetAtlasCategoryList', data)
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.categoryID
                        }
                    })
                    cb(list)
                })
        },
        //搜索图片标签组
        querySearchTagGroup(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            if (this.component_source.params.category_id) {
                params.category_id = this.component_source.params.category_id
            }
            GetAtlasTagGroup(params)
                .then(data => {
                    console.log('GetAtlasTagGroup', data)
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.groupID
                        }
                    })
                    cb(list)
                })
        },
        //搜索标签
        querySearchTag(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasTagList(params)
                .then(data => {
                    console.log('GetAtlasTagList', data)
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.tagID
                        }
                    })
                    cb(list)
                })
        },

        handleSelectMaterialGroup(item) {
            this.queryStringMaterialGroup = item.value
            this.component_source.params.material_group_id = item.id
            //辅助回显信息
            this.component_source.ignore.material_group_name = item.value
        },
        handleSelectCategory(item) {
            this.queryStringCategory = item.value
            this.component_source.params.category_id = item.id
            //辅助回显信息
            this.component_source.ignore.category_name = item.value
        },
        handleSelectTagGroup(item) {
            this.queryStringCategoryTagsTagGroup = item.value
            this.component_source.params.tag_group_id = item.id
            //辅助回显信息
            this.component_source.ignore.tag_group_name = item.value
        },
        handleSelectTag(item) {
            this.queryStringTag = item.value
            this.component_source.params.tag_id = item.id
            //辅助回显信息
            this.component_source.ignore.tag_name = item.value
        },
        handleSelectTagsTag(item) {
            this.queryStringTag = item.value
            if (this.component_source.params.tag_id_list.indexOf(item.id) == -1) {
                this.component_source.params.tag_id_list.push(item.id)
                if (!this.component_source.ignore.tag_list) {
                    this.component_source.ignore.tag_list = []
                }
                this.component_source.ignore.tag_list.push(item)
            }
        },
        //上移Tag
        handleMoveUpTag(item) {
            const index = this.component_source.ignore.tag_list.indexOf(item)
            if (index == 0) {
                this.$message.warning('已经到头了')
                return
            }
            let delItem = this.component_source.ignore.tag_list.splice(index, 1);
            this.component_source.ignore.tag_list.splice(index - 1, 0, ...delItem);

            const id = item.id;
            const id_index = this.component_source.params.tag_id_list.indexOf(id)
            if (id_index != -1 && id_index != 0) {
                this.component_source.params.tag_id_list.splice(index - 1, 0, ...id);
            }
        },
        //下移Tag
        handleMoveDownTag(item) {
            const index = this.component_source.ignore.tag_list.indexOf(item)
            if (index == this.component_source.ignore.tag_list.length - 1) {
                this.$message.warning('已经到底了')
                return
            }
            let delItem = this.component_source.ignore.tag_list.splice(index, 1);
            this.component_source.ignore.tag_list.splice(index + 1, 0, ...delItem);

            const id = item.id;
            const id_index = this.component_source.params.tag_id_list.indexOf(id)
            if (id_index != -1 && id_index != this.component_source.params.tag_id_list.length - 1) {
                this.component_source.params.tag_id_list.splice(index + 1, 0, ...id);
            }
        },
        //删除Tag
        handleDeleteTag(item) {
            const index = this.component_source.ignore.tag_list.indexOf(item)
            this.component_source.ignore.tag_list.splice(index, 1);

            const id = item.id;
            const id_index = this.component_source.params.tag_id_list.indexOf(id)
            if (id_index != -1) {
                this.component_source.params.tag_id_list.splice(id_index, 1);
            }
        }
    }
}
</script>

<style lang="less" scoped>

</style>